import { Box, Flex, Image, IconButton, Tooltip, Text } from '@chakra-ui/react';
import React from 'react';
import { pxToRem } from "../../utils/editor.ts";
import { LatexListData } from '../../types/latexPackage.ts';

type LatexItemRowProps = {
    resource: LatexListData,
    packageOnDelete: () => void,
    packageOnEdit?: (resource: LatexListData) => void  
}

{/* 没有多选功能 */}
const LatexItemRow: React.FC<LatexItemRowProps> = ({ resource, packageOnDelete,  packageOnEdit }) => {
    return (
        <Flex flexDir={'row'} justifyContent={'space-between'} pt={1}>
            <Flex flexDir={'row'} alignItems={'center'}>
                <Box>
                  <Tooltip placement={'left'} hasArrow  bg={'#FFF'} color={'#333'} label={resource.latexPackage}>
                    <Text 
                      style={{
                        margin: 0,
                        textDecoration: 'underline',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        width: pxToRem(170),
                        fontSize: pxToRem(15),
                        display: 'inline-block'
                    }}
                      cursor="pointer" 
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (packageOnEdit) packageOnEdit(resource);
                      }}
                    >
                      {resource.latexPackage}
                    </Text>
                  </Tooltip>
                </Box>
            </Flex>
            <Box>
                <IconButton
                  aria-label={'Delete button'}
                  bg={'transparent'}
                  h={pxToRem(18)}
                  _hover={{ bg: 'transparent' }}
                  onClick={packageOnDelete}
                  icon={<Image w={pxToRem(18)} src="/static/editor/citation_delete.svg" alt="Delete button" />}
                  // icon={<Image w={pxToRem(18)} src="/static/editor/delete-before.svg" alt="Delete button" />}
                >
                </IconButton>
            </Box>
        </Flex>
    )
}

export default LatexItemRow;